import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import userImage from "../assets/images/user.webp";
import checkWeb from "../assets/images/check.webp";
import logo from "../assets/images/logo.webp";
import FooterFixed from "./FooterFixed";
import { CHECK_EMAIL_DUPLICATE } from "../utils/constants";
import useCustomFormValidation from "../hooks/ErrorHandling/useCustomFormValidation";
import { ReactComponent as LeftSideArrowIcon } from "../assets/images/icons/LeftSideArrowIcon.svg";
import ZinancialLogo from "../assets/images/ZinancialLogo.webp";

const validationRules = {
  name: {
    required: true,
    errorMessage: "Name is required.",
  },
  email: [
    {
      required: true,
      errorMessage: "Email is required.",
    },
    {
      email: true,
      errorMessage: "Provide valid email",
    },
  ],
  password: [
    {
      required: true,

      errorMessage: "Password is required.",
    },
    {
      minLength: 8,
      errorMessage: "Password must be at least 8 characters.",
    },
  ],
  confirmPassword: {
    required: true,
    errorMessage: "Confirm Password is required.",
  },
};

const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setErrors] = useState(false);
  const [matchPassword, setMatchPassword] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid } = useCustomFormValidation(
    formData,
    validationRules
  );

  const handleInputChange = (event) => {
    handleChange(event);
    const { name, value } = event.target;
    if (name === "email") {
      checkEmailExists(value);
    } else if (name === "confirmPassword") {
      confirmPasswordMatch(value);
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const confirmPasswordMatch = (value) => {
    if (formData.password !== value) {
      setMatchPassword(formData.password !== value);
    } else {
      setMatchPassword("");
      setIsButtonDisabled(false);
    }
  };

  const checkEmailExists = async (email) => {
    try {
      const response = await fetch(`${CHECK_EMAIL_DUPLICATE}?email=${email}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.exists) {
        setErrors(true);
        setIsButtonDisabled(false);
      } else {
        setErrors(false);
        setIsButtonDisabled(false);
      }
    } catch (error) {
      console.error("Error checking email:", error);
    }
  };

  useEffect(() => {
    const savedData = localStorage.getItem("signupData");
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      setFormData(parsedData);
    }
    localStorage.removeItem("signupData");
  }, []);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      setIsButtonDisabled(false);
    }
  }, [formData]);
  const passwordsMatch = formData.password === formData.confirmPassword;
  const handleButtomClick = async (event) => {
    event.preventDefault();
    const formValid = isFormValid();

    if (
      !formValid ||
      !passwordsMatch ||
      error ||
      matchPassword ||
      formData.email === "" ||
      formData.full_name === "" ||
      formData.password === ""
    ) {
      setMatchPassword(!passwordsMatch);
      return;
    }

    delete formData.confirmPassword;

    localStorage.setItem("signupData", JSON.stringify(formData));

    navigate("/addorganization", { state: { signupData: formData } });
  };

  const handleClick = () => {
    navigate("/");
  };

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
  const toggleConfirmPasswordVisibility = () => setShowConfirmPassword((prev) => !prev);

  return (
    <div className="bg-white h-screen flex flex-col">
      <Link to="/" className="w-40 p-4 cursor-pointer ">
        <img src={ZinancialLogo} alt="Zinancial Logo" />
      </Link>
      <Link to="/" className="w-40 px-4 cursor-pointer ">
        <button className="flex  bg-F4F4F4 border border-EAE2E2 rounded-lg py-2  px-5 gap-4 items-center">
          <LeftSideArrowIcon />
          <span className="text-[#535252] text-lg font-medium">BACK</span>
        </button>
      </Link>
      <div class="flex items-center justify-center ">
        <div className="px-5 py-12 border-[#EDEDED] border rounded mx-28 w-[32rem] max-w-xl stroke-[#EDEDED]  stroke-1 shadow ">
          <div className="text-1D5D9B text-24 font-700  px-5 text-center">Sign Up</div>
          <div className="flex flex-col gap-4">
            <form onSubmit={(e) => e.preventDefault()} id="loginForm" className="px-5">
              <div className="grid grid-row space-y-4 gap-x-5">
                <div className="mt-3">
                  <label htmlFor="name" className="text-545B61 text-14 font-500 mb-2">
                    Full Name{" "}
                    {errors.name && formData.full_name === "" && (
                      <span className="text-red-500 font-normal text-12">{errors.name}</span>
                    )}
                  </label>
                  <input
                    onBlur={handleBlur}
                    className="border-1 border-E4EDF3 rounded-md focus:outline outline-1D5D9B focus:border-sky-700 w-full px-4"
                    type="text"
                    id="full_name"
                    placeholder="Full Name"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div>
                  <label htmlFor="email" className="text-545B61 text-14 font-500 mb-2">
                    Email{" "}
                    {errors.email && formData.email === "" ? (
                      <span className="text-red-500 font-normal text-12">{errors.email}</span>
                    ) : error === true ? (
                      <span className="text-red-500 font-normal text-12">User Already Exist</span>
                    ) : (
                      ""
                    )}
                  </label>
                  <input
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    className="border-1 border-E4EDF3 rounded-md focus:outline outline-1D5D9B focus:border-sky-700 w-full px-4"
                    type="email"
                    id="email"
                    placeholder="Email address"
                    name="email"
                    value={formData.email}
                    required
                  />
                </div>

                <div className="relative">
                  <label htmlFor="password" className="text-545B61 text-14 font-500 mb-2">
                    Create Password{" "}
                    {errors.password && <span className="text-red-500 font-normal text-12">{errors.password}</span>}
                  </label>
                  <div className="relative">
                    <input
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      className="border-1 border-E4EDF3 rounded-md focus:outline outline-1D5D9B focus:border-sky-700 w-full px-4 pr-10"
                      id="password"
                      name="password"
                      value={formData.password}
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                    />
                    <span
                      className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-600"
                      onClick={togglePasswordVisibility}
                    >
                      <i className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`} />
                    </span>
                  </div>
                </div>

                <div className="relative mt-4">
                  <label htmlFor="confirmPassword" className="text-545B61 text-14 font-500 mb-2">
                    Confirm Password{" "}
                    {errors.confirmPassword && formData.confirmPassword === "" ? (
                      <span className="text-red-500 font-normal text-12">{errors.confirmPassword}</span>
                    ) : matchPassword ? (
                      <span className="text-red-500 font-normal text-12">Password does not match.</span>
                    ) : null}
                  </label>
                  <div className="relative">
                    <input
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      className={`border-1 border-E4EDF3 rounded-md focus:outline outline-1D5D9B focus:border-sky-700 w-full px-4 pr-10 ${
                        !passwordsMatch
                          ? "border-2 border-red-500 rounded-md bg-red-100 focus:outline outline-red-500 focus:border-red-500"
                          : ""
                      }`}
                      id="confirmPassword"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm Password"
                    />
                    <span
                      className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-600"
                      onClick={toggleConfirmPasswordVisibility}
                    >
                      <i className={`bi ${showConfirmPassword ? "bi-eye" : "bi-eye-slash"}`} />
                    </span>
                  </div>
                </div>
              </div>

              <button
                onClick={handleButtomClick}
                type="submit"
                className={`mt-5 bg-sky-700 w-full text-white font-bold py-1 rounded-md ${
                  isButtonDisabled ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isButtonDisabled}
              >
                Next
              </button>
            </form>
            <div className="flex items-center">
              <hr className="h-[1px] w-full bg-EDEDED" />
            </div>

            <div className="text-center text-545B61 text-lg font-normal">
              Already have an account?{" "}
              <a className="font-bold text-[#F16136] text-lg" onClick={handleClick}>
                Sign In
              </a>
            </div>
            <div className="flex justify-center text-center">
              <p className="text-center text-545B61 text-lg font-normal">
                By continuing, you are indicating that you have read and agree to the
                <a className="text-[#1D5D9B] text-lg font-bold"> Terms of Use</a> and{" "}
                <a className="text-[#1D5D9B] text-lg font-bold">Privacy Policy.</a>
              </p>
            </div>
          </div>
          <div>
            <FooterFixed />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
